import { render, staticRenderFns } from "./applition.vue?vue&type=template&id=19e32a52&scoped=true&"
import script from "./applition.vue?vue&type=script&lang=js&"
export * from "./applition.vue?vue&type=script&lang=js&"
import style0 from "./applition.vue?vue&type=style&index=0&id=19e32a52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e32a52",
  null
  
)

export default component.exports